'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import { IndentIcon, OutdentIcon } from 'foundations-assets';
import tinymce from 'tinymce';
import ControlButton from '../components/toolbar/ControlButton';
import { i18nNameSpace } from '../constants/hsformatting';
import { CANVAS_INDENT, CANVAS_OUTDENT } from '../constants/toolbar';
import { i18nWithNameSpace } from '../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = i18nWithNameSpace(i18nNameSpace);
const getOutdentClickHandler = editor => () => {
  editor.execCommand('Outdent');
};
const getIndentClickHandler = editor => () => {
  editor.execCommand('Indent');
};
const indentationControls = [{
  controlName: CANVAS_OUTDENT,
  iconName: 'outdent',
  icon: OutdentIcon,
  formatName: 'outdent',
  tooltip: 'tooltip.outdent',
  getClickHandler: getOutdentClickHandler
}, {
  controlName: CANVAS_INDENT,
  iconName: 'indent',
  icon: IndentIcon,
  formatName: 'indent',
  tooltip: 'tooltip.indent',
  getClickHandler: getIndentClickHandler
}];
export function addIndentationControls(editor) {
  indentationControls.forEach(({
    controlName,
    iconName,
    icon,
    formatName,
    tooltip,
    getClickHandler
  }) => {
    tinymce.canvas.addButton(editor, controlName, {
      renderControl: props => {
        const rest = _objectWithoutPropertiesLoose(props, _excluded);
        return /*#__PURE__*/_jsx(ControlButton, Object.assign({
          "data-test-id": controlName,
          editor: editor,
          formatName: formatName,
          iconName: iconName,
          icon: icon,
          tooltip: i18nKey(tooltip),
          onClick: getClickHandler(editor),
          selected: false
        }, rest));
      }
    });
  });
}